import { render } from "./PricelistComponent.vue?vue&type=template&id=1910698d"
import script from "./PricelistComponent.vue?vue&type=script&lang=js"
export * from "./PricelistComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__